import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const formatINR = (n) => {
  if (n == null || isNaN(n)) return "—";
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);
};

export function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

// Handles both the real Razorpay Checkout flow and the sandbox stub (when keys are absent).
export async function payViaGateway({ purpose, amount, ref_id, user }) {
  const { data: order } = await api.post("/payments/order", { purpose, amount, ref_id });
  if (order.stub || !order.key_id) {
    const { data } = await api.post("/payments/verify", { order_id: order.order_id });
    return { ...data, stub: true };
  }
  const ok = await loadRazorpayScript();
  if (!ok) throw new Error("Could not load the payment gateway");
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: order.key_id, amount: order.amount, currency: order.currency, order_id: order.order_id,
      name: "EBG FinCorp", description: purpose,
      prefill: { name: user?.name, email: user?.email, contact: user?.phone },
      theme: { color: "#D4AF37" },
      handler: async (resp) => {
        try {
          const { data } = await api.post("/payments/verify", {
            order_id: order.order_id, razorpay_payment_id: resp.razorpay_payment_id, razorpay_signature: resp.razorpay_signature,
          });
          resolve({ ...data, stub: false });
        } catch (e) { reject(e); }
      },
      modal: { ondismiss: () => reject(new Error("Payment cancelled")) },
    });
    rzp.open();
  });
}
